import { useForm } from "react-hook-form";
import { AnswerInput } from "../AnswerInput";
import { MultipleAnswerInput } from "../MultipleAnswerInput";
import { useEffect, useRef } from "react";

export const Step6 = ({ questions = [], answers = {}, updateAnswer }) => {
  const defaultValues = questions.reduce((acc, question) => {
    if (!question.allow_multiple_answers) {
      acc[String(question.id)] =
        answers[question.id] || question?.answer?.answer_text || "";
    }
    return acc;
  }, {});

  const { control, setValue } = useForm({
    defaultValues,
  });

  const prevAnswersRef = useRef(answers);

  useEffect(() => {
    questions.forEach((question) => {
      if (!question.allow_multiple_answers) {
        const questionId = String(question.id);
        const currentAnswer = answers[question.id];
        const prevAnswer = prevAnswersRef.current[question.id];

        if (currentAnswer !== prevAnswer && currentAnswer !== undefined) {
          setValue(questionId, currentAnswer, { shouldDirty: false });
        }
      }
    });

    prevAnswersRef.current = { ...answers };
  }, [answers, questions, setValue]);

  return (
    <div className="d-flex flex-column w-full" style={{ gap: "24px" }}>
      {questions?.length > 0 &&
        questions.map((question) => {
          if (question.allow_multiple_answers) {
            // Get defaultValue - should be an array
            let defaultValue = answers[question.id];

            // If not in answers, try to parse from question.answer.answer_text
            if (!defaultValue && question?.answer?.answer_text) {
              try {
                const answerText = question.answer.answer_text;
                if (
                  typeof answerText === "string" &&
                  answerText.trim().startsWith("[")
                ) {
                  defaultValue = JSON.parse(answerText);
                } else if (answerText) {
                  defaultValue = [answerText];
                } else {
                  defaultValue = [];
                }
              } catch {
                defaultValue = [];
              }
            }

            // Ensure it's an array
            if (!Array.isArray(defaultValue)) {
              defaultValue = [];
            }

            return (
              <MultipleAnswerInput
                key={question.id}
                questionId={question.id}
                label={question.question_text}
                defaultValue={defaultValue}
                onValueChange={(value) => {
                  if (updateAnswer) {
                    updateAnswer(question.id, value);
                  }
                }}
              />
            );
          }

          return (
            <AnswerInput
              control={control}
              key={question.id}
              name={String(question.id)}
              label={question.question_text}
              defaultValue={
                answers[question.id] || question?.answer?.answer_text || ""
              }
              onValueChange={(value) => {
                if (updateAnswer) {
                  updateAnswer(question.id, value);
                }
              }}
            />
          );
        })}
    </div>
  );
};
